import React, {useState} from 'react'
import {Tag, Input} from 'antd'

export function TagInput() {
  const [inputValue, setInputValue] = useState('')
  return (
    <Input value={inputValue} onChange={ev => setInputValue(ev.target.value)} />
  )
}
